import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  Box,
  Stack,
} from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import { useUser } from "../Contexts/UserContext";

const UserDetail = () => {
  const { user } = useUser();
  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  return (
    <div style={{ padding: "2rem 4rem" }}>
      <Stack mt={1} mb={1} textAlign="start">
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 0px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Profile
          <style>
            {`
  .heading2::after {
    content: "";
width: 120px;
height: 1px;
display: inline-block;
background: #D10101;
margin: 4px 10px;
  }
`}
          </style>
        </h2>
      </Stack>
      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={6} lg={4}>
            <Card raised>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingBottom: 2,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: getRandomColor(),
                      width: 56,
                      height: 56,
                      marginBottom: 2,
                    }}
                  >
                    {user.UserName.charAt(0)}
                  </Avatar>
                  <Typography variant="h5" component="div">
                    {user.Username}
                  </Typography>
                  <Typography variant="span" component="div">
                    {user.ClientName}({user.ClientId})
                  </Typography>

                  <Typography
                    color="text.secondary"
                    textTransform="uppercase"
                    fontWeight={600}
                  >
                    {user.RoleName}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textTransform="uppercase"
                  fontWeight={600}
                  letterSpacing={1}
                  fontSize={15}
                >
                  {user.TenantName}
                </Typography>
                {/* <Typography
                variant="body2"
                color="text.secondary"
                sx={{ marginTop: 1 }}
              >
                Location: {user.location}
              </Typography> */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default UserDetail;
